import controllerBinder from './../controllers/controller-binder';
import imgSrcController from './../controllers/image-src-controller';
import srcsetController from './../controllers/srcset-controller';
import imageRemoveController from './../controllers/image-remove-controller';
import internalController from './../controllers/internal-controller';

export type Controllers = {
    [key: string]: { callable: (document: HTMLElement) => void };
};

const controllers: Controllers = {
    imgSrcController,
    srcsetController,
    imageRemoveController,
    internalController,
};

function main() {
    controllerBinder(document.documentElement, controllers);
}

export default () => {
    document.addEventListener('DOMContentLoaded', main);
};
